import { FIND_STUDENT } from "../../routes";
import customAxios from "../../customAxios";
import { IFindUserInformation } from "../../../types/common.interface";

async function findStudent(props: IFindUserInformation) {
  let thisUrl = FIND_STUDENT + "?";
  thisUrl += props?.page  ? `page=${props.page}`    : 'page=1'   ;
  thisUrl += props?.limit ? `&limit=${props.limit}` : '&limit=10';

  const populateFields = "blocks";

  thisUrl += `&populate=${populateFields}`;

  let body: any = {};
  if (props?.search?.value) {
    body = {
      ...body,
      search: {
        searchMode : props?.search?.base ,
        searchValue: props?.search?.value,
      },
    };
  }

  try {
    return (await customAxios.post(thisUrl, body)).data;
  } catch (error: any) {
    console.error({ GET_ALL_COMPANY: error });
  }
}

export default findStudent;
